// src/components/Picture.tsx
import { buildOptimizedSources } from "../lib/images";

const defaultBucketBase =
  import.meta.env.VITE_PUBLIC_STORAGE_BASE ||
  "/storage/v1/object/public/episode-data";

export default function Picture({
  storageRoot,
  filename,
  bucketBase = defaultBucketBase,
  sizes = "(max-width: 1024px) 100vw, 50vw",
  alt = "",
  width,
  height,
  className,
  priority = false, // allow preloading on critical images
}: {
  storageRoot: string;
  filename: string;
  bucketBase?: string;
  sizes?: string;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
}) {
  const s = buildOptimizedSources(bucketBase, storageRoot, filename);

  if (import.meta.env.DEV) {
    console.debug("[Picture]", { bucketBase, storageRoot, filename, s });
  }

  const srcSetAvif = `${s.avif.lg}`;
  const srcSetWebp = `${s.webp.lg}`;

  return (
    <picture>
      <source type="image/avif" srcSet={srcSetAvif} sizes={sizes} />
      <source type="image/webp" srcSet={srcSetWebp} sizes={sizes} />
      <img
        src={s.webp.lg}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        fetchpriority={priority ? "high" : undefined}
        decoding="async"
        width={width}
        height={height}
        className={className}
        style={{
          // blur-up from tiny placeholder while decoding
          background: s.placeholder
            ? `url("${s.placeholder}") center / cover no-repeat`
            : undefined,
        }}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).src = s.fallback;
        }}
      />
    </picture>
  );
}
